/**
 * RitualGroupMessageBubble
 * Ritual group message bubble using shared MessageBubble component.
 * Adds edit for own messages, delete for all (moderation).
 */

import { useTranslation } from "@/language"
import type { RitualGroupMessage } from "../../types/ritual-group-chat.types"
import { MessageBubble } from "../shared/MessageBubble"

interface RitualGroupMessageBubbleProps {
  message: RitualGroupMessage
  isOwn: boolean
  onEdit?: (message: RitualGroupMessage) => void
  onDelete?: (messageId: string) => void
}

export function RitualGroupMessageBubble({
  message,
  isOwn,
  onEdit,
  onDelete,
}: RitualGroupMessageBubbleProps) {
  const { t } = useTranslation("chats")

  return (
    <MessageBubble
      content={message.content}
      isOwn={isOwn}
      isDeleted={message.isDeleted}
      deletedLabel={t("ritualGroupMessage.deleted")}
      senderId={message.sender?.id}
      senderName={message.sender?.name}
      senderPhoto={message.sender?.profilePhoto}
      onEdit={onEdit ? () => onEdit(message) : undefined}
      onDelete={onDelete ? () => onDelete(message.id) : undefined}
      editLabel={t("ritualGroupMessage.edit")}
      deleteLabel={t("ritualGroupMessage.delete")}
      confirmDeleteLabel={t("ritualGroupMessage.confirmDelete")}
      showMenuForAll
    />
  )
}
